// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__fN5Fa","buttons":"SendReceipts_buttons__2_E60","email":"SendReceipts_email__15NYp","bookApptTitle":"SendReceipts_bookApptTitle__2U6tf"};